// extracted by mini-css-extract-plugin
export var description = "category-list-module--description--fe941";
export var isCurrent = "category-list-module--isCurrent--e41d9";
export var liItem = "category-list-module--liItem--39409";
export var mFilter = "category-list-module--mFilter--d1da7";
export var root = "category-list-module--root--28060";